// src/data/walkthroughData.js

// Import your GIF files. Make sure these paths are EXACTLY correct!
import slide1Gif from '../images/gifs/step1.gif';
import slide2Gif from '../images/gifs/step2.gif';
import slide3Gif from '../images/gifs/step3.gif';
import slide4Gif from '../images/gifs/step4.gif';
import slide5Gif from '../images/gifs/step5.gif';
// import slide6Gif from '../images/gifs/step2_profile.gif';

// Define dynamic background colors or gradients for the page wrapper
const stepBackgrounds = [
  'linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)', // Light Aqua
  'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)', // Light Green
  'linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)', // Light Pink
  'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', // Light Blue
  'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', // Light Orange
  'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)'  // Light Purple
];

export const walkthroughData = [
  {
    id: 'step-01',
    title: "1. Welcome to RoomEase: Your Perfect Shared Living Starts Here",
    description: "Discover RoomEase effortlessly. Tap our app icon to launch into a world where finding your ideal roommate or flat is simplified. See our vibrant logo and intuitive home screen, designed for a seamless start to your shared living journey.",
    image: slide1Gif,
    alt: "RoomEase app launch, showing home navigation and app logo.",
    additionalText: "Experience the clean, user-friendly interface from the very first tap."
  },
  {
    id: 'step-02',
    title: "2. Quick & Secure Signup: Get Started in Seconds",
    description: "Your journey to compatible flatmates begins with a simple, secure signup. Just enter your phone number to create your RoomEase account. Fast, easy, and designed for your privacy, ensuring a smooth entry into our roommate finder community.",
    image: slide2Gif,
    alt: "RoomEase app signup process via phone number.",
    additionalText: "We prioritize your privacy and security, making account creation a breeze."
  },
  {
    id: 'step-03',
    title: "3. Complete Your Profile: Unlock Better Roommate Matches",
    description: "Fill out a few more essential details to enhance your RoomEase profile. The more information you provide (interests, habits, preferences), the better our system can connect you with truly compatible flatmates. Don't skip any fields to ensure you get the best matches!",
    image: slide3Gif,
    alt: "RoomEase app showing additional profile details being filled, highlighting mandatory fields.",
    additionalText: "A comprehensive profile leads to more relevant and successful roommate connections."
  },
  {
    id: 'step-04',
    title: "4. Define Your Ideal Match: Flat, Roommate, or Both?",
    description: "Personalize your search for the perfect shared living arrangement. Tell us your needs: 'Looking for a Flat' means you need a place; 'Looking for a Roommate' means you have a flat but need a flatmate; 'Both' means you're open to either. This helps us find your ideal compatible match.",
    image: slide4Gif,
    alt: "RoomEase app profile setup, explaining 'looking for flat', 'roommate', or 'both' options.",
    additionalText: "Your preferences guide our smart matching algorithm for optimal results."
  },
  {
    id: 'step-05',
    title: "5. Swipe to Connect: Discover Your Next Flatmate",
    description: "Explore potential flatmates with our intuitive swipe interface. Swipe right to express interest, left to pass. When there's mutual interest, it's a match! This fun and engaging process helps you find compatible individuals for shared living.",
    image: slide5Gif,
    alt: "RoomEase app demonstrating left and right swiping for roommate profiles and a successful match.",
    additionalText: "Our smart matching system makes finding your ideal living partner enjoyable."
  },
  {
    id: 'step-06',
    title: "6. Seamless Chat: Connect & Plan with Your Matches",
    description: "Once you've matched with a potential flatmate, connect instantly through our secure in-app chat. Discuss expectations, share details, and plan your next steps for shared living. Our chat feature ensures smooth, private conversations for a stress-free experience.",
    // image: slide6Gif,
    alt: "RoomEase app displaying the in-app chat feature with messages being exchanged.",
    additionalText: "Communicate comfortably and securely to ensure a perfect living arrangement."
  },
];

// Map backgrounds to steps (or cycle if fewer backgrounds than steps)
export const getStepBackground = (index) => {
    return stepBackgrounds[index % stepBackgrounds.length];
};